// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/functions/v1/functions.proto" (package "c1.api.functions.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../../google/protobuf/struct";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * Function represents a customer-provided code extension in the API
 *
 * @generated from protobuf message c1.api.functions.v1.Function
 */
export interface Function {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 5;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 6;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionType function_type = 7;
     */
    functionType: FunctionType;
    /**
     * @generated from protobuf field: string published_commit_id = 8;
     */
    publishedCommitId: string;
    /**
     * @generated from protobuf field: string head = 9;
     */
    head: string;
    /**
     * @generated from protobuf field: bool is_draft = 10;
     */
    isDraft: boolean;
    /**
     * @generated from protobuf field: map<string, string> secret = 11;
     */
    secret: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: repeated string outbound_network_allowlist = 12;
     */
    outboundNetworkAllowlist: string[];
    /**
     * Scoped role IDs define the permissions granted to this function when calling
     * ConductorOne APIs. These are role IDs (not service roles) that get resolved
     * to their service roles at authentication time.
     *
     * Currently only the "Read-Only Administrator" role (system:viewer) is supported.
     * The role ID can be obtained from the roles API.
     *
     * @generated from protobuf field: repeated string scoped_role_ids = 13;
     */
    scopedRoleIds: string[];
}
/**
 * FunctionRef is a lightweight reference to a Function
 *
 * @generated from protobuf message c1.api.functions.v1.FunctionRef
 */
export interface FunctionRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionCommitRef
 */
export interface FunctionCommitRef {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionInvocationRef
 */
export interface FunctionInvocationRef {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionLogRef
 */
export interface FunctionLogRef {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string invocation_id = 2;
     */
    invocationId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
}
/**
 * FunctionCommit represents a single commit in a function's history
 *
 * @generated from protobuf message c1.api.functions.v1.FunctionCommit
 */
export interface FunctionCommit {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: string author = 3;
     */
    author: string;
    /**
     * @generated from protobuf field: string message = 4;
     */
    message: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsSearchRequest
 */
export interface FunctionsSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionType function_types = 2;
     */
    functionTypes: FunctionType[];
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsSearchResponse
 */
export interface FunctionsSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.Function list = 1;
     */
    list: Function[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionRequest
 */
export interface FunctionsExecutorServiceGetFunctionRequest {
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionResponse
 */
export interface FunctionsExecutorServiceGetFunctionResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1;
     */
    function?: Function;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigRequest
 */
export interface FunctionsExecutorServiceGetFunctionConfigRequest {
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigResponse
 */
export interface FunctionsExecutorServiceGetFunctionConfigResponse {
    /**
     * @generated from protobuf field: bytes encrypted_function_config = 1;
     */
    encryptedFunctionConfig: Uint8Array;
    /**
     * @generated from protobuf field: repeated string outbound_network_allowlist = 2;
     */
    outboundNetworkAllowlist: string[];
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionRequest
 */
export interface FunctionsServiceGetFunctionRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionResponse
 */
export interface FunctionsServiceGetFunctionResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1;
     */
    function?: Function;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceDeleteFunctionRequest
 */
export interface FunctionsServiceDeleteFunctionRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * Empty response
 *
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceDeleteFunctionResponse
 */
export interface FunctionsServiceDeleteFunctionResponse {
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListFunctionsRequest
 */
export interface FunctionsServiceListFunctionsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListFunctionsResponse
 */
export interface FunctionsServiceListFunctionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.Function list = 1;
     */
    list: Function[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateFunctionRequest
 */
export interface FunctionsServiceCreateFunctionRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionType function_type = 3;
     */
    functionType: FunctionType;
    /**
     * @generated from protobuf field: map<string, bytes> initial_content = 4;
     */
    initialContent: {
        [key: string]: Uint8Array;
    };
    /**
     * @generated from protobuf field: string commit_message = 5;
     */
    commitMessage: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateFunctionResponse
 */
export interface FunctionsServiceCreateFunctionResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1;
     */
    function?: Function;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionCommit commit = 2;
     */
    commit?: FunctionCommit;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceUpdateFunctionRequest
 */
export interface FunctionsServiceUpdateFunctionRequest {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1;
     */
    function?: Function;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceUpdateFunctionResponse
 */
export interface FunctionsServiceUpdateFunctionResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1;
     */
    function?: Function;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyRequest
 */
export interface FunctionsServiceGetFunctionSecretEncryptionKeyRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyResponse
 */
export interface FunctionsServiceGetFunctionSecretEncryptionKeyResponse {
    /**
     * @generated from protobuf field: bytes public_key = 1;
     */
    publicKey: Uint8Array; // JWK-formatted public key for encrypting secrets
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetCommitRequest
 */
export interface FunctionsExecutorServiceGetCommitRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetCommitResponse
 */
export interface FunctionsExecutorServiceGetCommitResponse {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "commit";
        /**
         * @generated from protobuf field: c1.api.functions.v1.FunctionCommit commit = 1;
         */
        commit: FunctionCommit;
    } | {
        oneofKind: "fileChunk";
        /**
         * @generated from protobuf field: c1.api.functions.v1.FileChunk file_chunk = 2;
         */
        fileChunk: FileChunk;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionLog
 */
export interface FunctionLog {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2;
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionLogLevel level = 3;
     */
    level: FunctionLogLevel;
    /**
     * @generated from protobuf field: string message = 4;
     */
    message: string;
    /**
     * @generated from protobuf field: int64 sequence = 5;
     */
    sequence: number;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest
 */
export interface FunctionsExecutorServiceUpdateLogsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry logs = 1;
     */
    logs: FunctionsExecutorServiceUpdateLogsRequest_LogEntry[];
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry
 */
export interface FunctionsExecutorServiceUpdateLogsRequest_LogEntry {
    /**
     * @generated from protobuf field: string invocation_id = 1;
     */
    invocationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2;
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionLogLevel level = 3;
     */
    level: FunctionLogLevel;
    /**
     * @generated from protobuf field: string message = 4;
     */
    message: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsResponse
 */
export interface FunctionsExecutorServiceUpdateLogsResponse {
    /**
     * @generated from protobuf field: bool acknowledged = 1;
     */
    acknowledged: boolean;
    /**
     * @generated from protobuf field: int32 logs_received = 2;
     */
    logsReceived: number;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceListLogsRequest
 */
export interface FunctionsInvocationServiceListLogsRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string invocation_id = 2;
     */
    invocationId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceListLogsResponse
 */
export interface FunctionsInvocationServiceListLogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionLog list = 1;
     */
    list: FunctionLog[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetCommitRequest
 */
export interface FunctionsServiceGetCommitRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetCommitResponse
 */
export interface FunctionsServiceGetCommitResponse {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "commit";
        /**
         * @generated from protobuf field: c1.api.functions.v1.FunctionCommit commit = 1;
         */
        commit: FunctionCommit;
    } | {
        oneofKind: "fileChunk";
        /**
         * @generated from protobuf field: c1.api.functions.v1.FileChunk file_chunk = 2;
         */
        fileChunk: FileChunk;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FileChunk
 */
export interface FileChunk {
    /**
     * @generated from protobuf field: string filename = 1;
     */
    filename: string;
    /**
     * @generated from protobuf field: bytes data = 2;
     */
    data: Uint8Array;
    /**
     * @generated from protobuf field: bool is_last_chunk = 3;
     */
    isLastChunk: boolean;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateInitialCommitRequest
 */
export interface FunctionsServiceCreateInitialCommitRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: repeated string filenames = 2;
     */
    filenames: string[]; // list of filenames to upload
    /**
     * @generated from protobuf field: string commit_message = 3;
     */
    commitMessage: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateInitialCommitResponse
 */
export interface FunctionsServiceCreateInitialCommitResponse {
    /**
     * @generated from protobuf field: string commit_id = 1;
     */
    commitId: string;
    /**
     * @generated from protobuf field: map<string, string> upload_urls = 2;
     */
    uploadUrls: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateFinalCommitRequest
 */
export interface FunctionsServiceCreateFinalCommitRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string commit_id = 2;
     */
    commitId: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateFinalCommitResponse
 */
export interface FunctionsServiceCreateFinalCommitResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionCommit commit = 1;
     */
    commit?: FunctionCommit;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListCommitsRequest
 */
export interface FunctionsServiceListCommitsRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListCommitsResponse
 */
export interface FunctionsServiceListCommitsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionCommit list = 1;
     */
    list: FunctionCommit[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateTagRequest
 */
export interface FunctionsServiceCreateTagRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string commit_id = 2;
     */
    commitId: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateTagResponse
 */
export interface FunctionsServiceCreateTagResponse {
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListTagsRequest
 */
export interface FunctionsServiceListTagsRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListTagsResponse
 */
export interface FunctionsServiceListTagsResponse {
    /**
     * @generated from protobuf field: map<string, c1.api.functions.v1.FunctionCommit> tags = 1;
     */
    tags: {
        [key: string]: FunctionCommit;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceInvokeRequest
 */
export interface FunctionsServiceInvokeRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string commit_id = 2;
     */
    commitId: string;
    /**
     * @generated from protobuf oneof: arg
     */
    arg: {
        oneofKind: "json";
        /**
         * @generated from protobuf field: bytes json = 100;
         */
        json: Uint8Array;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceInvokeResponse
 */
export interface FunctionsServiceInvokeResponse {
    /**
     * @generated from protobuf field: string invocation_id = 1;
     */
    invocationId: string;
    /**
     * @generated from protobuf oneof: resp
     */
    resp: {
        oneofKind: "json";
        /**
         * @deprecated
         * @generated from protobuf field: bytes json = 100 [deprecated = true];
         */
        json: Uint8Array;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceListRequest
 */
export interface FunctionsInvocationServiceListRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceListResponse
 */
export interface FunctionsInvocationServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionInvocation list = 1;
     */
    list: FunctionInvocation[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceGetRequest
 */
export interface FunctionsInvocationServiceGetRequest {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceGetResponse
 */
export interface FunctionsInvocationServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionInvocation invocation = 1;
     */
    invocation?: FunctionInvocation;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionInvocation
 */
export interface FunctionInvocation {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string function_id = 2;
     */
    functionId: string;
    /**
     * @generated from protobuf field: string commit_id = 3;
     */
    commitId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct input = 6;
     */
    input?: Struct;
    /**
     * @generated from protobuf field: google.protobuf.Struct output = 7;
     */
    output?: Struct;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionInvocationStatus status = 8;
     */
    status: FunctionInvocationStatus;
    /**
     * @generated from protobuf field: string error = 9;
     */
    error: string;
}
/**
 * Function types match the model representation
 *
 * @generated from protobuf enum c1.api.functions.v1.FunctionType
 */
export enum FunctionType {
    /**
     * @generated from protobuf enum value: FUNCTION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FUNCTION_TYPE_ANY = 1;
     */
    ANY = 1
}
/**
 * @generated from protobuf enum c1.api.functions.v1.FunctionLogLevel
 */
export enum FunctionLogLevel {
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_INFO = 1;
     */
    INFO = 1,
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_WARN = 2;
     */
    WARN = 2,
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_DEBUG = 4;
     */
    DEBUG = 4
}
/**
 * @generated from protobuf enum c1.api.functions.v1.FunctionInvocationStatus
 */
export enum FunctionInvocationStatus {
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_SUCCESS = 3;
     */
    SUCCESS = 3,
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_ERROR = 4;
     */
    ERROR = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class Function$Type extends MessageType<Function> {
    constructor() {
        super("c1.api.functions.v1.Function", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 7, name: "function_type", kind: "enum", T: () => ["c1.api.functions.v1.FunctionType", FunctionType, "FUNCTION_TYPE_"] },
            { no: 8, name: "published_commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "head", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "secret", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "validate.rules": { map: { minPairs: "0", maxPairs: "32", keys: { string: { minBytes: "1", maxBytes: "256", pattern: "^[a-zA-Z0-9_]+$" } }, values: { string: { maxBytes: "4096" } } } } } },
            { no: 12, name: "outbound_network_allowlist", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { minBytes: "1", maxBytes: "2048", pattern: "^((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|(\\d{1,3}(\\.\\d{1,3}){3})):([1-9]\\d{0,3}|[1-5]\\d{4}|6[0-4]\\d{3}|65[0-4]\\d{2}|655[0-2]\\d|6553[0-5])$" } } } } } },
            { no: 13, name: "scoped_role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", unique: true, items: { string: { minBytes: "1", maxBytes: "256" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Function" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.Function
 */
export const Function = new Function$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionRef$Type extends MessageType<FunctionRef> {
    constructor() {
        super("c1.api.functions.v1.FunctionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionRef
 */
export const FunctionRef = new FunctionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionCommitRef$Type extends MessageType<FunctionCommitRef> {
    constructor() {
        super("c1.api.functions.v1.FunctionCommitRef", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionCommitRef
 */
export const FunctionCommitRef = new FunctionCommitRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionInvocationRef$Type extends MessageType<FunctionInvocationRef> {
    constructor() {
        super("c1.api.functions.v1.FunctionInvocationRef", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionInvocationRef
 */
export const FunctionInvocationRef = new FunctionInvocationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionLogRef$Type extends MessageType<FunctionLogRef> {
    constructor() {
        super("c1.api.functions.v1.FunctionLogRef", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionLogRef
 */
export const FunctionLogRef = new FunctionLogRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionCommit$Type extends MessageType<FunctionCommit> {
    constructor() {
        super("c1.api.functions.v1.FunctionCommit", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "author", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionCommit
 */
export const FunctionCommit = new FunctionCommit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsSearchRequest$Type extends MessageType<FunctionsSearchRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 2, name: "function_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.functions.v1.FunctionType", FunctionType, "FUNCTION_TYPE_"] },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsSearchRequest
 */
export const FunctionsSearchRequest = new FunctionsSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsSearchResponse$Type extends MessageType<FunctionsSearchResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Function },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsSearchResponse
 */
export const FunctionsSearchResponse = new FunctionsSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetFunctionRequest$Type extends MessageType<FunctionsExecutorServiceGetFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetFunctionRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionRequest
 */
export const FunctionsExecutorServiceGetFunctionRequest = new FunctionsExecutorServiceGetFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetFunctionResponse$Type extends MessageType<FunctionsExecutorServiceGetFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetFunctionResponse", [
            { no: 1, name: "function", kind: "message", T: () => Function }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionResponse
 */
export const FunctionsExecutorServiceGetFunctionResponse = new FunctionsExecutorServiceGetFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetFunctionConfigRequest$Type extends MessageType<FunctionsExecutorServiceGetFunctionConfigRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigRequest
 */
export const FunctionsExecutorServiceGetFunctionConfigRequest = new FunctionsExecutorServiceGetFunctionConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetFunctionConfigResponse$Type extends MessageType<FunctionsExecutorServiceGetFunctionConfigResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigResponse", [
            { no: 1, name: "encrypted_function_config", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "outbound_network_allowlist", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigResponse
 */
export const FunctionsExecutorServiceGetFunctionConfigResponse = new FunctionsExecutorServiceGetFunctionConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetFunctionRequest$Type extends MessageType<FunctionsServiceGetFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetFunctionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionRequest
 */
export const FunctionsServiceGetFunctionRequest = new FunctionsServiceGetFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetFunctionResponse$Type extends MessageType<FunctionsServiceGetFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetFunctionResponse", [
            { no: 1, name: "function", kind: "message", T: () => Function }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionResponse
 */
export const FunctionsServiceGetFunctionResponse = new FunctionsServiceGetFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceDeleteFunctionRequest$Type extends MessageType<FunctionsServiceDeleteFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceDeleteFunctionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceDeleteFunctionRequest
 */
export const FunctionsServiceDeleteFunctionRequest = new FunctionsServiceDeleteFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceDeleteFunctionResponse$Type extends MessageType<FunctionsServiceDeleteFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceDeleteFunctionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceDeleteFunctionResponse
 */
export const FunctionsServiceDeleteFunctionResponse = new FunctionsServiceDeleteFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListFunctionsRequest$Type extends MessageType<FunctionsServiceListFunctionsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListFunctionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListFunctionsRequest
 */
export const FunctionsServiceListFunctionsRequest = new FunctionsServiceListFunctionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListFunctionsResponse$Type extends MessageType<FunctionsServiceListFunctionsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListFunctionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Function },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListFunctionsResponse
 */
export const FunctionsServiceListFunctionsResponse = new FunctionsServiceListFunctionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateFunctionRequest$Type extends MessageType<FunctionsServiceCreateFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateFunctionRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 3, name: "function_type", kind: "enum", T: () => ["c1.api.functions.v1.FunctionType", FunctionType, "FUNCTION_TYPE_"] },
            { no: 4, name: "initial_content", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 12 /*ScalarType.BYTES*/ } },
            { no: 5, name: "commit_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateFunctionRequest
 */
export const FunctionsServiceCreateFunctionRequest = new FunctionsServiceCreateFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateFunctionResponse$Type extends MessageType<FunctionsServiceCreateFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateFunctionResponse", [
            { no: 1, name: "function", kind: "message", T: () => Function },
            { no: 2, name: "commit", kind: "message", T: () => FunctionCommit }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateFunctionResponse
 */
export const FunctionsServiceCreateFunctionResponse = new FunctionsServiceCreateFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceUpdateFunctionRequest$Type extends MessageType<FunctionsServiceUpdateFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceUpdateFunctionRequest", [
            { no: 1, name: "function", kind: "message", T: () => Function },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceUpdateFunctionRequest
 */
export const FunctionsServiceUpdateFunctionRequest = new FunctionsServiceUpdateFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceUpdateFunctionResponse$Type extends MessageType<FunctionsServiceUpdateFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceUpdateFunctionResponse", [
            { no: 1, name: "function", kind: "message", T: () => Function }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceUpdateFunctionResponse
 */
export const FunctionsServiceUpdateFunctionResponse = new FunctionsServiceUpdateFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetFunctionSecretEncryptionKeyRequest$Type extends MessageType<FunctionsServiceGetFunctionSecretEncryptionKeyRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyRequest
 */
export const FunctionsServiceGetFunctionSecretEncryptionKeyRequest = new FunctionsServiceGetFunctionSecretEncryptionKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetFunctionSecretEncryptionKeyResponse$Type extends MessageType<FunctionsServiceGetFunctionSecretEncryptionKeyResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyResponse", [
            { no: 1, name: "public_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyResponse
 */
export const FunctionsServiceGetFunctionSecretEncryptionKeyResponse = new FunctionsServiceGetFunctionSecretEncryptionKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetCommitRequest$Type extends MessageType<FunctionsExecutorServiceGetCommitRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetCommitRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetCommitRequest
 */
export const FunctionsExecutorServiceGetCommitRequest = new FunctionsExecutorServiceGetCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetCommitResponse$Type extends MessageType<FunctionsExecutorServiceGetCommitResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetCommitResponse", [
            { no: 1, name: "commit", kind: "message", oneof: "message", T: () => FunctionCommit },
            { no: 2, name: "file_chunk", kind: "message", oneof: "message", T: () => FileChunk }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetCommitResponse
 */
export const FunctionsExecutorServiceGetCommitResponse = new FunctionsExecutorServiceGetCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionLog$Type extends MessageType<FunctionLog> {
    constructor() {
        super("c1.api.functions.v1.FunctionLog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "level", kind: "enum", T: () => ["c1.api.functions.v1.FunctionLogLevel", FunctionLogLevel, "FUNCTION_LOG_LEVEL_"] },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sequence", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionLog
 */
export const FunctionLog = new FunctionLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceUpdateLogsRequest$Type extends MessageType<FunctionsExecutorServiceUpdateLogsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest", [
            { no: 1, name: "logs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionsExecutorServiceUpdateLogsRequest_LogEntry, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest
 */
export const FunctionsExecutorServiceUpdateLogsRequest = new FunctionsExecutorServiceUpdateLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceUpdateLogsRequest_LogEntry$Type extends MessageType<FunctionsExecutorServiceUpdateLogsRequest_LogEntry> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry", [
            { no: 1, name: "invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "level", kind: "enum", T: () => ["c1.api.functions.v1.FunctionLogLevel", FunctionLogLevel, "FUNCTION_LOG_LEVEL_"] },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "65536" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry
 */
export const FunctionsExecutorServiceUpdateLogsRequest_LogEntry = new FunctionsExecutorServiceUpdateLogsRequest_LogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceUpdateLogsResponse$Type extends MessageType<FunctionsExecutorServiceUpdateLogsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsResponse", [
            { no: 1, name: "acknowledged", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "logs_received", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsResponse
 */
export const FunctionsExecutorServiceUpdateLogsResponse = new FunctionsExecutorServiceUpdateLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceListLogsRequest$Type extends MessageType<FunctionsInvocationServiceListLogsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceListLogsRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceListLogsRequest
 */
export const FunctionsInvocationServiceListLogsRequest = new FunctionsInvocationServiceListLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceListLogsResponse$Type extends MessageType<FunctionsInvocationServiceListLogsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceListLogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionLog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceListLogsResponse
 */
export const FunctionsInvocationServiceListLogsResponse = new FunctionsInvocationServiceListLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetCommitRequest$Type extends MessageType<FunctionsServiceGetCommitRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetCommitRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^(HEAD|[a-zA-Z0-9]{27}|refs/tags/[a-zA-Z0-9._-]+)$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetCommitRequest
 */
export const FunctionsServiceGetCommitRequest = new FunctionsServiceGetCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetCommitResponse$Type extends MessageType<FunctionsServiceGetCommitResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetCommitResponse", [
            { no: 1, name: "commit", kind: "message", oneof: "message", T: () => FunctionCommit },
            { no: 2, name: "file_chunk", kind: "message", oneof: "message", T: () => FileChunk }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetCommitResponse
 */
export const FunctionsServiceGetCommitResponse = new FunctionsServiceGetCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileChunk$Type extends MessageType<FileChunk> {
    constructor() {
        super("c1.api.functions.v1.FileChunk", [
            { no: 1, name: "filename", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "is_last_chunk", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FileChunk
 */
export const FileChunk = new FileChunk$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateInitialCommitRequest$Type extends MessageType<FunctionsServiceCreateInitialCommitRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateInitialCommitRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "filenames", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commit_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateInitialCommitRequest
 */
export const FunctionsServiceCreateInitialCommitRequest = new FunctionsServiceCreateInitialCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateInitialCommitResponse$Type extends MessageType<FunctionsServiceCreateInitialCommitResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateInitialCommitResponse", [
            { no: 1, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "upload_urls", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateInitialCommitResponse
 */
export const FunctionsServiceCreateInitialCommitResponse = new FunctionsServiceCreateInitialCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateFinalCommitRequest$Type extends MessageType<FunctionsServiceCreateFinalCommitRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateFinalCommitRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateFinalCommitRequest
 */
export const FunctionsServiceCreateFinalCommitRequest = new FunctionsServiceCreateFinalCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateFinalCommitResponse$Type extends MessageType<FunctionsServiceCreateFinalCommitResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateFinalCommitResponse", [
            { no: 1, name: "commit", kind: "message", T: () => FunctionCommit }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateFinalCommitResponse
 */
export const FunctionsServiceCreateFinalCommitResponse = new FunctionsServiceCreateFinalCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListCommitsRequest$Type extends MessageType<FunctionsServiceListCommitsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListCommitsRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListCommitsRequest
 */
export const FunctionsServiceListCommitsRequest = new FunctionsServiceListCommitsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListCommitsResponse$Type extends MessageType<FunctionsServiceListCommitsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListCommitsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionCommit },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListCommitsResponse
 */
export const FunctionsServiceListCommitsResponse = new FunctionsServiceListCommitsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateTagRequest$Type extends MessageType<FunctionsServiceCreateTagRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateTagRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^(HEAD|[a-zA-Z0-9]{27}|refs/tags/[a-zA-Z0-9._-]+)$" } } } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "100", pattern: "^(refs/tags/)?[a-zA-Z0-9._-]+$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateTagRequest
 */
export const FunctionsServiceCreateTagRequest = new FunctionsServiceCreateTagRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateTagResponse$Type extends MessageType<FunctionsServiceCreateTagResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateTagResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateTagResponse
 */
export const FunctionsServiceCreateTagResponse = new FunctionsServiceCreateTagResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListTagsRequest$Type extends MessageType<FunctionsServiceListTagsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListTagsRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListTagsRequest
 */
export const FunctionsServiceListTagsRequest = new FunctionsServiceListTagsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListTagsResponse$Type extends MessageType<FunctionsServiceListTagsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListTagsResponse", [
            { no: 1, name: "tags", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FunctionCommit } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListTagsResponse
 */
export const FunctionsServiceListTagsResponse = new FunctionsServiceListTagsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceInvokeRequest$Type extends MessageType<FunctionsServiceInvokeRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceInvokeRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "json", kind: "scalar", oneof: "arg", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceInvokeRequest
 */
export const FunctionsServiceInvokeRequest = new FunctionsServiceInvokeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceInvokeResponse$Type extends MessageType<FunctionsServiceInvokeResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceInvokeResponse", [
            { no: 1, name: "invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "json", kind: "scalar", oneof: "resp", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceInvokeResponse
 */
export const FunctionsServiceInvokeResponse = new FunctionsServiceInvokeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceListRequest$Type extends MessageType<FunctionsInvocationServiceListRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceListRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceListRequest
 */
export const FunctionsInvocationServiceListRequest = new FunctionsInvocationServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceListResponse$Type extends MessageType<FunctionsInvocationServiceListResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionInvocation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceListResponse
 */
export const FunctionsInvocationServiceListResponse = new FunctionsInvocationServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceGetRequest$Type extends MessageType<FunctionsInvocationServiceGetRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceGetRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceGetRequest
 */
export const FunctionsInvocationServiceGetRequest = new FunctionsInvocationServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceGetResponse$Type extends MessageType<FunctionsInvocationServiceGetResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceGetResponse", [
            { no: 1, name: "invocation", kind: "message", T: () => FunctionInvocation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceGetResponse
 */
export const FunctionsInvocationServiceGetResponse = new FunctionsInvocationServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionInvocation$Type extends MessageType<FunctionInvocation> {
    constructor() {
        super("c1.api.functions.v1.FunctionInvocation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "input", kind: "message", T: () => Struct },
            { no: 7, name: "output", kind: "message", T: () => Struct },
            { no: 8, name: "status", kind: "enum", T: () => ["c1.api.functions.v1.FunctionInvocationStatus", FunctionInvocationStatus, "FUNCTION_INVOCATION_STATUS_"] },
            { no: 9, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionInvocation
 */
export const FunctionInvocation = new FunctionInvocation$Type();
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsExecutorService
 */
export const FunctionsExecutorService = new ServiceType("c1.api.functions.v1.FunctionsExecutorService", [
    { name: "GetFunction", options: { "authz.method": { role: "VIEWER" } }, I: FunctionsExecutorServiceGetFunctionRequest, O: FunctionsExecutorServiceGetFunctionResponse },
    { name: "GetCommit", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: FunctionsExecutorServiceGetCommitRequest, O: FunctionsExecutorServiceGetCommitResponse },
    { name: "GetFunctionConfig", options: { "authz.method": { role: "VIEWER" } }, I: FunctionsExecutorServiceGetFunctionConfigRequest, O: FunctionsExecutorServiceGetFunctionConfigResponse },
    { name: "UpdateLogs", options: { "authz.method": { role: "VIEWER" } }, I: FunctionsExecutorServiceUpdateLogsRequest, O: FunctionsExecutorServiceUpdateLogsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsService
 */
export const FunctionsService = new ServiceType("c1.api.functions.v1.FunctionsService", [
    { name: "GetFunction", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Function", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Function" }] } }, I: FunctionsServiceGetFunctionRequest, O: FunctionsServiceGetFunctionResponse },
    { name: "DeleteFunction", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/functions/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Function" }], group: "Function" }] } }, I: FunctionsServiceDeleteFunctionRequest, O: FunctionsServiceDeleteFunctionResponse },
    { name: "ListFunctions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions", stability: "STABILITY_DRAFT", group: "Function" }] } }, I: FunctionsServiceListFunctionsRequest, O: FunctionsServiceListFunctionsResponse },
    { name: "CreateFunction", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Function" }], group: "Function" }] } }, I: FunctionsServiceCreateFunctionRequest, O: FunctionsServiceCreateFunctionResponse },
    { name: "UpdateFunction", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions/update", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Function" }], group: "Function" }] } }, I: FunctionsServiceUpdateFunctionRequest, O: FunctionsServiceUpdateFunctionResponse },
    { name: "GetCommit", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: FunctionsServiceGetCommitRequest, O: FunctionsServiceGetCommitResponse },
    { name: "CreateInitialCommit", options: { "authz.method": { role: "EDITOR" } }, I: FunctionsServiceCreateInitialCommitRequest, O: FunctionsServiceCreateInitialCommitResponse },
    { name: "CreateFinalCommit", options: { "authz.method": { role: "EDITOR" } }, I: FunctionsServiceCreateFinalCommitRequest, O: FunctionsServiceCreateFinalCommitResponse },
    { name: "ListCommits", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{function_id}/commits", stability: "STABILITY_DRAFT", group: "Function Commit" }] } }, I: FunctionsServiceListCommitsRequest, O: FunctionsServiceListCommitsResponse },
    { name: "CreateTag", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions/{function_id}/tags", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Function_Tag" }], group: "Function Tag" }] } }, I: FunctionsServiceCreateTagRequest, O: FunctionsServiceCreateTagResponse },
    { name: "ListTags", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{function_id}/tags", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Function_Tag" }], group: "Function Tag" }] } }, I: FunctionsServiceListTagsRequest, O: FunctionsServiceListTagsResponse },
    { name: "Invoke", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions/{function_id}/invoke", stability: "STABILITY_DRAFT", group: "Function" }] } }, I: FunctionsServiceInvokeRequest, O: FunctionsServiceInvokeResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsInvocationService
 */
export const FunctionsInvocationService = new ServiceType("c1.api.functions.v1.FunctionsInvocationService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{function_id}/invocations", stability: "STABILITY_DRAFT", group: "Function Invocation" }] } }, I: FunctionsInvocationServiceListRequest, O: FunctionsInvocationServiceListResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{function_id}/invocations/{id}", stability: "STABILITY_DRAFT", group: "Function Invocation" }] } }, I: FunctionsInvocationServiceGetRequest, O: FunctionsInvocationServiceGetResponse },
    { name: "ListLogs", options: { "authz.method": { role: "VIEWER" } }, I: FunctionsInvocationServiceListLogsRequest, O: FunctionsInvocationServiceListLogsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsSearch
 */
export const FunctionsSearch = new ServiceType("c1.api.functions.v1.FunctionsSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/functions", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Function", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Function" }] } }, I: FunctionsSearchRequest, O: FunctionsSearchResponse }
]);
